
import { Box, Container } from "@mui/material";
import CardServices from "../cardServices";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import RegisterAccess from '../../../utils/registerAccess';
// import { useSelector } from 'react-redux';


interface MenuState {
  solicitacoesAnalise: number;
  autorizadoAnaliseLaboratorial: number;
  analiseAmostra: number;
  analiseRelatorio: number;
  reclamacoes: number;
  analiseFinalizado: number;
}
type MenuProps = {
  styles: string
}

export default function MenuControleQualidade({ styles }: MenuProps) {
  // const user = useSelector(state => state.account.user);

  const [menu, setMenu] = useState<MenuState>({
    solicitacoesAnalise: 0,
    autorizadoAnaliseLaboratorial: 0,
    analiseAmostra: 0,
    analiseRelatorio: 0,
    analiseFinalizado: 0,
    reclamacoes: 0,
  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true)

  useEffect(() => {
    api.get(`/menu/dcqmts`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
    <Container>
      <RegisterAccess page={'menu controleQualidade'} />

      <Box className={styles}>
        <CardServices funcao='Técnico' load={loadMenu} count={menu.solicitacoesAnalise} icone={'/icones/controleQualidade/solicitacoesAnalise.svg'} nomeService={'Solicitaçōes de Análise '} link={'/admin/dcqmts/solicitacoes-de-analise/Análise'} />
        <CardServices load={loadMenu} count={menu.reclamacoes} icone={'/icones/Reclamacoes.svg'} nomeService={'Reclamações'} link={'/admin/reclamacoes?page=1'} />
      </Box>

      <Box className={styles}>
        {/* <CardServices funcao='Chefe de Departamento'  load={loadMenu} count={menu.deferido} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={''} /> */}
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.autorizadoAnaliseLaboratorial} icone={'/icones/chefeDepartamento.svg'} nomeService={'Autorização para Análise Laboratórial'} link={'/admin/dcqmts/solicitacoes-de-analise/Autorização para Análise Laboratorial'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.analiseAmostra} icone={'/icones/controleQualidade/analiseAmostraLaboratorioRelatorioAnalitico.svg'} nomeService={'Análise da Amostra no Laboratório e Relatório Análitico'} link={'/admin/dcqmts/solicitacoes-de-analise/Análise da Amostra'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.analiseRelatorio} icone={'/icones/controleQualidade/RevisaoRelatorioAnalitico.svg'} nomeService={'Revisão do Relatório Análitico'} link={'/admin/dcqmts/solicitacoes-de-analise/Análise do Relatório'} />
        {/* <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.analiseRelatorio} icone={'/icones/controleQualidade/EmissaoCertificadoAnaliseQualidade.svg'} nomeService={'Emissão de Certificado de Análise de Qualidade'} link={''} /> */}
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.analiseFinalizado} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Certificados e Autorizações'} link={'/admin/dcqmts/solicitacoes-de-analise/Emissão da Autorização de Liberação de Lote'} />
      </Box>
    </Container>
  )
}


